module.exports = __webpack_public_path__ + "assets/img/ambition-5.708ddeea.svg";